import { Box, Typography } from '@mui/material';
import { RowCell } from './RowCell';
import { IconButton } from '@ui/buttons';

import { OneOfListElements } from '@shared/models/project.model';
import { SectionRowContentProps } from './list.model';
import { guards } from '@shared/helpers/typeguards.helpers';

export const DefaultSectionRowContent = <T extends OneOfListElements>({
  section,
  expanded,
  isHovered,
  onExpandToggle,
}: SectionRowContentProps<T>) => {
  return (
    <RowCell gap={0}>
      <IconButton
        category="mui"
        icon="ArrowDropDown"
        disabled={guards.is.undefined(onExpandToggle)}
        hidden={!isHovered}
        rotateIcon={expanded ? 0 : -90}
        onClick={onExpandToggle}
        shape="square"
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          gap: 3,
        }}
      >
        <Typography
          component="span"
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
        >
          {section.label}
        </Typography>
        <Typography
          component="span"
          variant="body2"
          sx={{
            color: 'text.subtle',
          }}
        >
          {section.items.length} item{section.items.length > 1 ? 's' : ''}
        </Typography>
      </Box>
    </RowCell>
  );
};
